import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class AuthorizationDataService extends DataService {

	constructor(http: HttpClient) {
		super(http);
	}

//	getRoles(): Promise<string[]> {
//		return this.get<string[]>('System/SecurityRoles');
//	}
}
